import { isNil } from 'ramda'

import {
  showDefaultError,
  showNoConnectionError,
  showRequestError,
  showServerError,
  showTimeoutError,
} from './error-modal-builder'
import { networkStatusCode } from './network-status-code'

/**
 * Minimal shape of Apollo's onError link payload. Inlined here so the
 * DS doesn't take a runtime dependency on @apollo/client — host apps
 * that use Apollo cast their own `ErrorResponse` to this shape.
 */
type ErrorResponse = {
  networkError?:
    | { statusCode?: number; message?: string; name?: string }
    | Error
    | null
}

export const parseApolloError = ({ networkError }: ErrorResponse) =>
  parseStatus(
    networkError && 'statusCode' in networkError
      ? networkError.statusCode
      : undefined
  )

export const parseStatus = (statusCode: number | undefined) => {
  if (isNil(statusCode) && !window.navigator.onLine) {
    return showNoConnectionError()
  }

  if (isNil(statusCode)) {
    return showDefaultError()
  }

  if (statusCode === networkStatusCode.timeout) {
    return showTimeoutError()
  }

  if (
    statusCode >= networkStatusCode.badRequest &&
    statusCode < networkStatusCode.internalServerError
  ) {
    return showRequestError()
  }

  return showServerError()
}
